// sort.ts
import type { IListItem } from './listItem.js';

function pinRank(i: IListItem): number {
  if (i.isCritical) return 0;
  if (i.isSafety) return 1;
  if (i.isRejected) return 2;
  if (i.isOverdue) return 3;
  return 99; // unpinned
}

// Plain ordinal compare — the values are ASCII (ISO YYYY-MM-DD dates, item keys),
// so byte order == chronological/lexical order. Avoids localeCompare's Intl
// collator, which dominates the sort at a few thousand items.
const cmp = (a: string, b: string): number => (a < b ? -1 : a > b ? 1 : 0);

export function sortListItems(items: IListItem[]): IListItem[] {
  return [...items].sort((a, b) => {
    const ra = pinRank(a);
    const rb = pinRank(b);
    const pa = ra === 99 ? 1 : 0;
    const pb = rb === 99 ? 1 : 0;
    if (pa !== pb) return pa - pb;          // pinned tier first
    if (pa === 0 && ra !== rb) return ra - rb; // within pinned, by rank
    const byDate = cmp(a.date, b.date); // primary: by date (activity start / issue due)
    if (byDate !== 0) return byDate;
    // Tie-break so same-start items don't appear in arbitrary order: by end date,
    // then a stable key — otherwise the end-date column looks unsorted.
    const byEnd = cmp(a.end ?? a.date, b.end ?? b.date);
    if (byEnd !== 0) return byEnd;
    return cmp(a.key, b.key);
  });
}
